/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import _ from 'lodash';
import Backbone from 'backbone';

import AttachmentCardsCollectionView from '../../../common/views/AttachmentCardsCollectionView/AttachmentCardsCollectionView';

import tmplGroupAttachmentCardItemView from './GroupAttachmentCardItemView.hbs';

const GroupAttachmentCardItemView = View.extend({
  template: tmplGroupAttachmentCardItemView,

  className: 'card-item-view',

  ui: {
    orderCards: '.order-cards'
  },

  regions: {
    orderCards: '@ui.orderCards'
  },

  onRender() {
    const numOfAttachments = this.model.get('orders').length;
    _.each(this.model.get('orders'), (orderAttachments, index) => {
      orderAttachments.documentTypes = this.model.get('documentTypes');
      if (index === numOfAttachments - 1) {
        orderAttachments.lastOrder = true;
      }
      orderAttachments.isReadOnly = this.model.get('isReadOnly');
      orderAttachments.isAdHocEditable = this.model.get('isAdHocEditable');
    });
    this.collection = new Backbone.Collection(this.model.get('orders'));

    this.attachmentsCollectionView = new AttachmentCardsCollectionView({
      collection: this.collection
    });
    this.showChildView('orderCards', this.attachmentsCollectionView);
  }
});

export default GroupAttachmentCardItemView;
